/* unplugin-vue-components disabled */import script from "./emoji-picker-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./emoji-picker-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./style/index.scss?vue&type=style&index=0&id=7484be6a&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7484be6a"]])

export default __exports__